// constants
import { showSuccessAlert } from "../../constants/alerts";
import { SubActionTypes } from "./constants";

const INIT_STATE = {
  subs: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface subData {
  id: string;
  email: string;
}

interface SubActionType {
  type:
    | SubActionTypes.API_RESPONSE_SUCCESS
    | SubActionTypes.API_RESPONSE_ERROR
    | SubActionTypes.GET_SUB
    | SubActionTypes.DELETE_SUB;
  payload: {
    actionType?: string;
    data?: subData | {};
    error?: string;
    category?: [];
  };
}

interface State {
  subs?: subData[] | [];
  loading?: boolean;
  value?: boolean;
}

const Subscriptions = (state: State = INIT_STATE, action: SubActionType): any => {
  switch (action.type) {
    case SubActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case SubActionTypes.GET_SUB: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            subs: action.payload.data,
          };
        }

        case SubActionTypes.DELETE_SUB: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case SubActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case SubActionTypes.GET_SUB: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case SubActionTypes.DELETE_SUB: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case SubActionTypes.GET_SUB:
      return { ...state, loading: true, initialLoading: true };
    case SubActionTypes.DELETE_SUB:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default Subscriptions;
